import React from "react";

const InputLabel = ({ children, className }) => {
  return <label className={className}> {children} </label>;
};

export default InputLabel;
